import Reveal from "@/components/site/Reveal";

const steps = [
  {
    n: "01",
    title: "Conversation",
    body: "We talk. About your company, your audience, and what success actually looks like — no jargon.",
  },
  {
    n: "02",
    title: "Direction",
    body: "I sketch a design direction, set the visual language, and lock the scope so we both know exactly what's being built.",
  },
  {
    n: "03",
    title: "Build",
    body: "I design and develop in parallel, sharing progress along the way. Real code, custom every step.",
  },
  {
    n: "04",
    title: "Launch & beyond",
    body: "We ship. Then I stay close — small tweaks, new sections, future phases. Same email, same person.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="font-mono-label text-[11px] text-violet-400 mb-6">
            03 / How it works
          </div>
          <h2
            data-testid="process-heading"
            className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-white max-w-3xl"
          >
            A simple, four-step process. <span className="text-white/60">No surprises.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
          {steps.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 100}
              y={24}
              data-testid={`process-step-${i}`}
              className="flex gap-6 group"
            >
              <div className="font-display text-5xl md:text-6xl font-black text-white/10 group-hover:text-violet-400 transition-colors duration-500 leading-none">
                {s.n}
              </div>
              <div className="flex-1 pt-2 border-t border-white/10 group-hover:border-violet-400/40 transition-colors duration-500">
                <h3 className="font-display text-xl md:text-2xl font-bold text-white mt-4 mb-2">
                  {s.title}
                </h3>
                <p className="text-white/55 leading-relaxed text-sm md:text-base">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
